import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-card-ranking',
    templateUrl: './card-ranking.component.html',
    styleUrls: ['./card-ranking.component.scss'],
})
export class CardRankingComponent implements OnInit {
    @Input() linkRoute: string;
    @Input() ranking;

    constructor() {}

    ngOnInit(): void {}
}
